<template>
  <div class="system-setting">
   <!--<div class="top">
     <a-button type="primary">添加</a-button>
   </div>

   <a-table :columns="columns" :dataSource="data">
    <a slot="action" href="javascript:;">Delete</a>
    <p slot="expandedRowRender" slot-scope="record" style="margin: 0">{{record.description}}</p>
  </a-table> -->
  
  <a-tabs defaultActiveKey="1" tabPosition="left" :tabBarStyle="{width: '200px',height:'100%',background:'#fff',}">
      <a-tab-pane tab="标签管理" key="1">
        <!-- <SettingLabel /> -->
      </a-tab-pane>
      <a-tab-pane tab="认证类别管理" v-if="role =='ADMIN'" key="2">
        <!-- <CertificateType /> -->
      </a-tab-pane>
      <a-tab-pane tab="报告类别管理" v-if="role =='ADMIN'" key="3">
        <!-- <ReportType /> -->
      </a-tab-pane>
  </a-tabs>


  </div>
</template>

<script>
import SettingLabel from './systemSetting/SettingLabel';
// import CertificateType from './systemSetting/CertificateType';
// import ReportType from './systemSetting/ReportType';
import Cookies from 'js-cookie'

export default {
  components: { SettingLabel },
  // components: { SettingLabel,CertificateType,ReportType },
  data() {
    return {
      // userinfo:'',
      role:'1',
    }
  },
  created() {
    // this.userinfo =  Cookies.get('userinfo')

    // console.log("this.userinfo",JSON.parse(this.userinfo).roles[0])
    // this.role = JSON.parse(this.userinfo).roles[0]
  },
};
</script>

<style lang="less" scoped>
.system-setting {
  height: 100%;
  // background-color: #fff;
  .ant-tabs {
    height: 100%;

    /deep/.ant-tabs-left-bar { 
      padding: 10px 0;

      .ant-tabs-tab {
        font-weight: bold;
        font-size: 14px;
        text-align:center;
        height: 40px;
        line-height: 40px;
        padding: 0;

        &.ant-tabs-tab-active {background-color: #e6f7ff;}
      }
    }
    /deep/.ant-tabs-content {
      height: 100%;
      padding: 0px;
      
    }
  }
}
</style>
